import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Stop } from "@app/shared/models/tour.type";
import { extractStopLinks } from "@app/shared/hooks/extract-stop-links";
import { useRecoilState, useSetRecoilState } from "recoil";
import { atom_openedStopState } from "@app/shared/state/opened-stop.atom";
import { atom_scrollTarget } from "@app/shared/state/scroll-target.atom";
import { atom_activeStopState } from "@app/shared/state/active-stop.atom";
import { atom_modalType } from "@app/shared/state/show-content-modal.atom";
import { useTranslation } from "react-i18next";



const LinksContent: React.FC = () => {
    // This hook uses decompress internally to extract htmlButtonDivs

    const [state_openedStopState, setState_openedStopState] = useRecoilState(atom_openedStopState);
    const setState_scrollTarget = useSetRecoilState(atom_scrollTarget);
    const [state_activeStopState, setState_activeStopState] = useRecoilState(atom_activeStopState);
    const linksElements = extractStopLinks(state_activeStopState, state_activeStopState?.s_title);
    const [responsiveModalType, setResponsiveModalType] = useRecoilState(atom_modalType);
    const { t } = useTranslation();
    const handleStopCardClick = (stop: Stop) => {
        setState_openedStopState(stop);
    };

    function cssStringToObject(cssString: string = "") {
        return cssString
            .split(";")
            .filter(Boolean)
            .reduce((acc, rule) => {
                const [key, value] = rule.split(":");
                if (key && value) {
                    const jsKey = key.trim().replace(/-([a-z])/g, (_, char) => char.toUpperCase());
                    (acc as any)[jsKey] = value.trim();
                }
                return acc;
            }, {} as React.CSSProperties);
    }

    return (
        <Box
            sx={{
                height: "100%",
                overflowY: "auto",
                width: "100%",
                marginTop: '30px',
                borderRadius: "8px",
                paddingBottom: '10px',
            }}
        >
            <Typography variant="h6" sx={{ mb: 4, mt: 2, px: '4px', textAlign: "center" }}>
                {t("on_tour.stop.stops_links")} - {state_activeStopState?.s_title}
            </Typography>
            {linksElements.length === 0 && (
                <button style={{ display: 'none' }} tabIndex={0}>Hidden Fallback</button>
            )}
            {linksElements.map((divObj, idx) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(divObj.html, "text/html");
                const aTag = doc.querySelector("a");
                const aText = aTag?.textContent?.trim();
                const aStyle = aTag?.getAttribute("style");
                return (
                    <Box
                        key={idx}
                        sx={{
                            mb: 3,
                            width: "86%",
                            marginLeft: "auto",
                            marginRight: "auto",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                        className="flex justify-center align-center"
                    >
                        {aTag ? (
                            <Button
                                fullWidth
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (state_activeStopState) {
                                        handleStopCardClick(state_activeStopState);

                                        // Set scroll target after a small delay to ensure modal closes and content renders
                                        setTimeout(() => {
                                            setState_scrollTarget(`media-title-${divObj.name}`);
                                        }, 100);
                                    }
                                }}
                            >
                                {aText}
                            </Button>
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: divObj.html }} />
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default LinksContent;

